import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const TwoBarsIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <rect
      fill="currentColor"
      height="12"
      opacity="0.2"
      rx="1"
      transform="matrix(-1 0 0 1 14 2)"
      width="2"
    />
    <rect fill="currentColor" height="8" rx="1" transform="matrix(-1 0 0 1 9.5 6)" width="2" />
    <rect fill="currentColor" height="4" rx="1" transform="matrix(-1 0 0 1 5 10)" width="2" />
  </svg>
);
